import { useSeriesCardContext } from './series-card'
import React from 'react'
import { cn } from 'src/lib/utils'

interface SeriesCardTitleProps {
  className?: string
}

export const SeriesCardTitle = ({ className }: SeriesCardTitleProps): React.ReactElement => {
  const { series } = useSeriesCardContext()

  return (
    <h3 className={cn('text-ivory text-2xl lg:text-4xl font-evogria uppercase text-left line-clamp-2', className)}>
      {series.title}
    </h3>
  )
}
